/**
 * Created by ah on 04/01/17.
 */
import api from '../apiClient';
import * as Immutable from 'immutable';
import {Keys, Actions} from '../constants';
import {defaultAsyncActionFactory} from './action-utils'

export const loadItems =  defaultAsyncActionFactory(
    Actions.GET_ITEMS,
    Keys.StoreSliceData.ITEMS,
    api.getItems
);
export const loadWorkSessionItems = (workSessionId) => (dispatch, getState) => {
    dispatch({type: Actions.GET_ITEMS+'_REQUEST'});
    return api.getWorkSessionItems(workSessionId).then(response => {
        return dispatch({
            type: Actions.GET_ITEMS+'_SUCCESS',
            payload: {[Keys.StoreSliceData.ITEMS]: response.data},
            currentWorkSession: getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION, Immutable.Map())
        });
    }).then(() => {
        // Update assignees with assigned items
        return dispatch({
            type: Actions.ITEMS_UPDATED,
            payload: {[Keys.StoreSliceData.ITEMS]:getState().itemsState.get(Keys.StoreSliceData.ITEMS, Immutable.Map())}
        });
    }).catch(error => {
       dispatch({type: Actions.GET_ITEMS+'_FAILURE', payload: {message: error.message}});
       return Promise.reject(error);

    })

};

export const searchItems = (query) => (dispatch, getState) => {
    dispatch({type: Actions.GET_SEARCH_ITEMS+'_REQUEST'});
    return api.getSearchItems(query).then(response => {
        return dispatch({
            type: Actions.GET_SEARCH_ITEMS+'_SUCCESS',
            payload: {[Keys.StoreSliceData.ITEMS]: response.data},
            currentWorkSession: getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION, Immutable.Map())});

    }).then(() => {
        // Update assignees with assigned items
        return dispatch({
            type: Actions.ITEMS_UPDATED,
            payload: {[Keys.StoreSliceData.ITEMS]:getState().itemsState.get(Keys.StoreSliceData.ITEMS, Immutable.Map())}
        });
    }).catch(error => {
        dispatch({type: Actions.GET_SEARCH_ITEMS+'_FAILURE', payload: {message: error.message}});
        return Promise.reject(error);
    })

};




// WEBPACK FOOTER //
// ./src/model/action-creators/item-actions.js